/** Default desktop side panel width (app shell + routes). */
export const DEFAULT_SIDE_PANEL_WIDTH_PX = 448

/**
 * Legacy right-rail width for booking-preview positioning when `--shell-side-panel-inset`
 * is unset (pre–product-refresh `LegacyAppLayout`).
 */
export const LEGACY_BOOKING_PREVIEW_INSET_PX = 440

/** Minimum side panel width in split mode (drag floor). */
export const MIN_SIDE_PANEL_WIDTH_PX = 360

/** Minimum usable center column width before the side panel collapses over it. */
export const MIN_CENTER_PANEL_WIDTH_PX = 400

/** Hit target width for the vertical resize handle. */
export const RESIZE_HANDLE_WIDTH_PX = 16

export type ShellBodyLayoutMode = 'split' | 'center-collapsed'

/** Set on `#shell-side-panel` and `document.documentElement` for shell panel width. */
export const SHELL_SIDE_PANEL_WIDTH_VAR = '--shell-side-panel-width'

/**
 * Viewport inset for fixed overlays (e.g. booking preview) — panel width plus `#shell-body`
 * padding/gap (and resize handle when drag is on). Published by app-shell `SidePanel`.
 */
export const SHELL_SIDE_PANEL_INSET_VAR = '--shell-side-panel-inset'

/** Container name on `#shell-side-panel-content` for narrow-panel layout rules. */
export const SHELL_SIDE_PANEL_CONTAINER_NAME = 'shell-side-panel'

/** `data-testid` on app shell side panel content (container query root). */
export const SHELL_SIDE_PANEL_CONTENT_TEST_ID = 'shell-side-panel-content'

/** ET footer and similar chrome adapt below this width (min panel 360px + padding). */
export const SHELL_SIDE_PANEL_COMPACT_MAX_WIDTH_PX = 400 - 2

/** Container query when the shell side panel is at or near min drag width. */
export const shellSidePanelCompact = `@container ${SHELL_SIDE_PANEL_CONTAINER_NAME} (max-width: ${SHELL_SIDE_PANEL_COMPACT_MAX_WIDTH_PX}px)`
